import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { BlogListItem } from './blog.models';

@Component({
  selector: 'app-blog-card',
  templateUrl: './blog-card.component.html',
  styleUrls: ['./blog-card.component.scss'],
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BlogCardComponent {
  @Input({ required: true }) item!: BlogListItem;

  get hasCover(): boolean {
    return Boolean(this.item?.coverImageUrl);
  }
}
